(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-about-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-about-hero::before y lee esta variable.
        hero.style.setProperty('--tl-about-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-cookie-consent"]) return;
  try {
    
  (function () {
    var root = document.getElementById('tl-cookie');
    if (!root) return;

    var STORAGE_KEY = 'tl-cookie-consent';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function show() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-visible'); });
    }
    function hide() {
      root.classList.remove('is-visible');
      if (reduce.matches) {
        root.hidden = true;
      } else {
        setTimeout(function () { root.hidden = true; }, 240);
      }
    }
    function setView(name) {
      var views = root.querySelectorAll('.tl-cookie__view');
      for (var i = 0; i < views.length; i++) {
        views[i].hidden = views[i].getAttribute('data-view') !== name;
      }
    }

    function persistLocal(consent) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), c: consent })); } catch (e) {}
    }
    function hasLocal() {
      try { return !!localStorage.getItem(STORAGE_KEY); } catch (e) { return false; }
    }

    function apply(consent) {
      persistLocal(consent);
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === 'function') {
        try {
          api.setTrackingConsent({
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            preferences: !!consent.preferences,
            sale_of_data: !!consent.marketing
          }, function () {});
        } catch (e) {}
      }
      hide();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tl-cookie]');
      if (!btn) return;
      var action = btn.getAttribute('data-tl-cookie');

      if (action === 'accept') {
        apply({ analytics: true, marketing: true, preferences: true });
      } else if (action === 'decline') {
        apply({ analytics: false, marketing: false, preferences: false });
      } else if (action === 'manage') {
        setView('prefs');
      } else if (action === 'back') {
        setView('main');
      } else if (action === 'save') {
        var get = function (k) {
          var el = root.querySelector('[data-tl-pref="' + k + '"]');
          return el ? el.checked : false;
        };
        apply({ analytics: get('analytics'), marketing: get('marketing'), preferences: get('preferences') });
      }
    });

    // A choice already made — via our banner (which calls setTrackingConsent,
    // so consent values become non-empty) or Shopify's own banner, or stored
    // locally as a fallback.
    function alreadyDecided(api) {
      if (hasLocal()) return true;
      try {
        var c = api && api.currentVisitorConsent && api.currentVisitorConsent();
        if (c && (c.analytics || c.marketing || c.preferences || c.sale_of_data)) return true;
      } catch (e) {}
      return false;
    }

    // Show whenever a consent decision is pending. shouldShowBanner alone only
    // covers GDPR/CCPA regions; isRegulationEnforced catches the broader case
    // where the shop collects consent in other regions too (parity with the
    // native banner). No API → show until a local choice exists.
    function shouldShow(api) {
      if (!api) return !hasLocal();
      if (alreadyDecided(api)) return false;
      var checks = ['shouldShowBanner', 'shouldShowGDPRBanner', 'shouldShowCCPABanner', 'isRegulationEnforced'];
      for (var i = 0; i < checks.length; i++) {
        try {
          if (typeof api[checks[i]] === 'function' && api[checks[i]]()) return true;
        } catch (e) {}
      }
      return false;
    }

    function decide() {
      if (shouldShow(window.Shopify && window.Shopify.customerPrivacy)) show();
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { decide(); }
      );
    } else {
      decide();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-get-started"] && !Shopify.designMode) return;
  try {
    
/* Parallax del hero — desplaza .tl-gs-hero::before con el scroll. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-gs-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-gs-hero::before y lee esta variable.
        hero.style.setProperty('--tl-gs-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function init(root) {
    if (!root || root.dataset.gsReady) return;
    root.dataset.gsReady = 'true';

    var state = {
      path: null,
      cat: null,
      bundle: null,
      rxFile: null,
      idFile: null,
      consents: { c1: false, c2: false }
    };

    var progress = root.querySelector('[data-gs-progress]');
    var label3 = root.querySelector('[data-gs-label-3]');
    var pathContinue = root.querySelector('[data-gs-path-continue]');
    var bundleContinue = root.querySelector('[data-gs-bundle-continue]');
    var glp1Options = root.querySelector('[data-gs-glp1-options]');
    var hghOptions = root.querySelector('[data-gs-hgh-options]');
    var timeSlots = root.querySelector('[data-gs-time-slots]');

    function showPanel(id) {
      root.querySelectorAll('[data-gs-panel]').forEach(function (panel) {
        var match = panel.getAttribute('data-gs-panel') === String(id);
        panel.hidden = !match;
        panel.classList.toggle('is-active', match);
      });
      updateProgress(id);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateProgress(id) {
      if (id === 'confirm') {
        progress.classList.add('is-hidden');
        return;
      }
      progress.classList.remove('is-hidden');

      var step = 0;
      if (id === 0 || id === '0') step = 0;
      else if (id === 1 || id === '1') step = 1;
      else if (id === 2 || id === '2') step = 2;
      else if (id === '3A' || id === '3B' || id === '3C' || id === 3) step = 3;
      else if (id === 4 || id === '4') step = 4;

      for (var i = 1; i <= 4; i++) {
        var item = root.querySelector('[data-gs-step-indicator="' + i + '"]');
        var circle = item.querySelector('[data-gs-circle]');
        var line = root.querySelector('[data-gs-line="' + i + '"]');
        item.classList.remove('is-active', 'is-done');
        if (i < step) {
          item.classList.add('is-done');
          circle.textContent = '✓';
          if (line) line.classList.add('is-done');
        } else if (i === step) {
          item.classList.add('is-active');
          circle.textContent = String(i);
          if (line) line.classList.remove('is-done');
        } else {
          circle.textContent = String(i);
          if (line) line.classList.remove('is-done');
        }
      }
    }

    function medicationLabel() {
      if (state.cat === 'GLP1') {
        var sel = root.querySelector('[data-gs-med-glp1]');
        return sel && sel.value ? 'GLP-1 — ' + sel.value.split(' — ')[0] : 'GLP-1';
      }
      if (state.cat === 'HGH') {
        var selH = root.querySelector('[data-gs-med-hgh]');
        return selH && selH.value ? 'HGH — ' + selH.value.split(' — ')[0] : 'HGH';
      }
      return '—';
    }

    function populateSummary() {
      var first = (root.querySelector('[data-gs-first-name]').value || 'Jane').trim();
      var last = (root.querySelector('[data-gs-last-name]').value || 'Doe').trim();
      var email = (root.querySelector('[data-gs-email]').value || 'jane@email.com').trim();
      root.querySelector('[data-gs-summary-name]').textContent = first + ' ' + last;
      root.querySelector('[data-gs-summary-email]').textContent = email;
      root.querySelector('[data-gs-summary-path]').textContent =
        state.path === 'A' ? 'Has prescription' : 'Needs consultation';
      root.querySelector('[data-gs-summary-med]').textContent = medicationLabel();

      var rxRow = root.querySelector('[data-gs-summary-rx]');
      var idRow = root.querySelector('[data-gs-summary-id]');
      var bundleRow = root.querySelector('[data-gs-summary-bundle]');
      var showUploads = state.path === 'A';
      rxRow.hidden = !showUploads;
      idRow.hidden = !showUploads;

      if (state.path === 'A' && state.cat === 'GLP1' && state.bundle !== null) {
        bundleRow.hidden = false;
        root.querySelector('[data-gs-summary-bundle-val]').textContent =
          state.bundle === 'yes' ? 'Added' : 'Declined';
      } else {
        bundleRow.hidden = true;
      }
    }

    function goNext(target) {
      if (target === '3') {
        showPanel(state.path === 'A' ? '3A' : '3B');
        return;
      }
      if (target === '3A-continue') {
        showPanel(state.cat === 'GLP1' ? '3C' : '4');
        if (state.cat !== 'GLP1') populateSummary();
        return;
      }
      if (target === '4') {
        populateSummary();
        showPanel('4');
        return;
      }
      showPanel(target);
    }

    root.querySelectorAll('[data-gs-path]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.path = btn.getAttribute('data-gs-path');
        root.querySelectorAll('[data-gs-path]').forEach(function (el) {
          el.classList.toggle('is-selected', el === btn);
        });
        if (label3) label3.textContent = state.path === 'A' ? 'Prescription' : 'Consultation';
        pathContinue.disabled = false;
      });
    });

    root.querySelectorAll('[data-gs-cat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.cat = btn.getAttribute('data-gs-cat');
        root.querySelectorAll('[data-gs-cat]').forEach(function (el) {
          el.classList.toggle('is-selected', el === btn);
        });
        glp1Options.hidden = state.cat !== 'GLP1';
        hghOptions.hidden = state.cat !== 'HGH';
      });
    });

    root.querySelectorAll('[data-gs-bundle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.bundle = btn.getAttribute('data-gs-bundle');
        root.querySelectorAll('[data-gs-bundle]').forEach(function (el) {
          el.classList.toggle('is-selected', el === btn);
        });
        bundleContinue.disabled = false;
      });
    });

    function bindUpload(zoneAttr, fileAttr, stateKey) {
      var zone = root.querySelector('[data-gs-upload="' + zoneAttr + '"]');
      var input = root.querySelector(fileAttr);
      if (!zone || !input) return;
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        state[stateKey] = file.name;
        zone.classList.add('is-uploaded');
        zone.querySelector('[data-gs-upload-icon]').textContent = '✓';
        zone.querySelector('[data-gs-upload-label]').textContent = file.name;
        zone.querySelector('[data-gs-upload-sub]').textContent = 'Uploaded successfully — click to replace';
      });
    }
    bindUpload('rx', '[data-gs-file-rx]', 'rxFile');
    bindUpload('id', '[data-gs-file-id]', 'idFile');

    root.querySelectorAll('[data-gs-day]').forEach(function (day) {
      day.addEventListener('click', function () {
        root.querySelectorAll('[data-gs-day]').forEach(function (el) {
          el.classList.toggle('is-selected', el === day);
        });
        timeSlots.hidden = false;
      });
    });

    root.querySelectorAll('[data-gs-time]').forEach(function (slot) {
      slot.addEventListener('click', function () {
        root.querySelectorAll('[data-gs-time]').forEach(function (el) {
          el.classList.toggle('is-selected', el === slot);
        });
      });
    });

    root.querySelectorAll('[data-gs-consent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-gs-consent');
        state.consents[key] = !state.consents[key];
        btn.classList.toggle('is-checked', state.consents[key]);
      });
    });

    root.querySelectorAll('[data-gs-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        goNext(btn.getAttribute('data-gs-next'));
      });
    });

    var reviewBack = root.querySelector('[data-gs-review-back]');
    if (reviewBack) {
      reviewBack.addEventListener('click', function () {
        if (state.path === 'A' && state.cat === 'GLP1') showPanel('3C');
        else if (state.path === 'A') showPanel('3A');
        else showPanel('3B');
      });
    }

    var submit = root.querySelector('[data-gs-submit]');
    if (submit) {
      submit.addEventListener('click', function () {
        showPanel('confirm');
      });
    }

    updateProgress(0);
  }

  document.querySelectorAll('[data-tl-gs]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tl-gs]');
    if (root) {
      delete root.dataset.gsReady;
      init(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-how-it-works-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- FAQ: apertura/cierre suave del <details> nativo ---------------- */
  function initFaq() {
    var items = document.querySelectorAll('.tl-hiw-faq-item');
    Array.prototype.forEach.call(items, function (item) {
      var summary = item.querySelector('.tl-hiw-faq-item__q');
      var content = item.querySelector('.tl-hiw-faq-item__a');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        // Sin animación si el usuario prefiere movimiento reducido.
        if (reduce.matches) return;
        // Evita reentradas mientras una animación está en curso.
        if (item.dataset.animating) { e.preventDefault(); return; }
        e.preventDefault();

        if (item.open) {
          // ---- Cerrar: altura actual → 0, luego quitar [open] ----
          item.dataset.animating = '1';
          content.style.height = content.offsetHeight + 'px';
          content.offsetHeight; // reflow
          requestAnimationFrame(function () { content.style.height = '0px'; });
          content.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName !== 'height') return;
            content.removeEventListener('transitionend', te);
            item.open = false;
            content.style.height = '';
            delete item.dataset.animating;
          });
        } else {
          // ---- Abrir: render, medir, 0 → altura natural ----
          item.dataset.animating = '1';
          item.open = true;
          var end = content.scrollHeight;
          content.style.height = '0px';
          content.offsetHeight; // reflow
          requestAnimationFrame(function () { content.style.height = end + 'px'; });
          content.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName !== 'height') return;
            content.removeEventListener('transitionend', te);
            content.style.height = '';
            delete item.dataset.animating;
          });
        }
      });
    });
  }

  function init() {
    initFaq();

    var hero = document.querySelector('.tl-hiw-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-hiw-hero::before y lee esta variable.
        hero.style.setProperty('--tl-hiw-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-medications-glp1-page"] && !Shopify.designMode) return;
  try {
    
  /* Parallax del hero — desplaza .tl-glp1-hero::before con el scroll. */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initParallax() {
      var hero = document.querySelector('.tl-glp1-hero');
      if (!hero || reduce.matches) return;

      var ticking = false;

      function update() {
        var rect = hero.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        if (rect.bottom > 0 && rect.top < vh) {
          var total = vh + rect.height;
          var p = (vh - rect.top) / total;
          p = Math.max(0, Math.min(1, p));
          var maxShift = rect.height * 0.15;
          var offset = (p - 0.5) * 2 * maxShift;
          hero.style.setProperty('--tl-glp1-parallax', offset.toFixed(2) + 'px');
        }
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  })();

  // Filtro por molécula del SKU grid. Progressive enhancement: sin JS las
  // tres cards quedan visibles y la barra de filtros simplemente no filtra.
  document.querySelectorAll('.tl-glp1-filter-bar').forEach(function (bar) {
    var grid = document.querySelector('[data-sku-grid]');
    if (!grid) return;

    bar.addEventListener('click', function (event) {
      var button = event.target.closest('.tl-glp1-filter');
      if (!button) return;

      var molecule = button.dataset.molecule;

      bar.querySelectorAll('.tl-glp1-filter').forEach(function (filter) {
        var active = filter === button;
        filter.classList.toggle('tl-glp1-filter--active', active);
        filter.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      grid.querySelectorAll('.tl-glp1-sku').forEach(function (card) {
        card.hidden = molecule !== 'all' && card.dataset.molecule !== molecule;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-medications-hgh-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-hgh-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom > 0 && rect.top < vh) {
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;
        hero.style.setProperty('--tl-hgh-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-medications-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-meds-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-meds-hero::before y lee esta variable.
        hero.style.setProperty('--tl-meds-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-patient"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.patientReady) return;
    root.dataset.patientReady = 'true';

    var formState = root.querySelector('[data-patient-state="form"]');
    var confirmState = root.querySelector('[data-patient-state="confirm"]');
    var errorEl = root.querySelector('[data-patient-error]');
    var form = root.querySelector('[data-patient-form]');
    var emailInput = root.querySelector('[data-patient-email]');
    var confirmedEmail = root.querySelector('[data-patient-confirmed-email]');
    var timerEl = root.querySelector('[data-patient-timer]');
    var resetBtn = root.querySelector('[data-patient-reset]');

    var timerInterval = null;
    var timeLeft = 900;

    function showForm() {
      formState.hidden = false;
      confirmState.hidden = true;
      errorEl.hidden = true;
      stopTimer();
      timeLeft = 900;
      timerEl.classList.remove('is-warn', 'is-expired');
      timerEl.textContent = '15:00';
    }

    function showConfirm(email) {
      confirmedEmail.textContent = email;
      formState.hidden = true;
      confirmState.hidden = false;
      errorEl.hidden = true;
      startTimer();
    }

    function showError() {
      errorEl.hidden = false;
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function updateTimerDisplay() {
      if (timeLeft <= 0) {
        timerEl.textContent = 'Expired';
        timerEl.classList.remove('is-warn');
        timerEl.classList.add('is-expired');
        return;
      }
      var m = String(Math.floor(timeLeft / 60)).padStart(2, '0');
      var s = String(timeLeft % 60).padStart(2, '0');
      timerEl.textContent = m + ':' + s;
      timerEl.classList.toggle('is-warn', timeLeft < 60);
      timerEl.classList.remove('is-expired');
    }

    function startTimer() {
      stopTimer();
      timeLeft = 900;
      updateTimerDisplay();
      timerInterval = setInterval(function () {
        timeLeft -= 1;
        updateTimerDisplay();
        if (timeLeft <= 0) stopTimer();
      }, 1000);
    }

    function stopTimer() {
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (emailInput.value || '').trim();
      if (!isValidEmail(email)) {
        showError();
        emailInput.focus();
        return;
      }
      showConfirm(email);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        emailInput.value = '';
        showForm();
        emailInput.focus();
      });
    }
  }

  document.querySelectorAll('[data-tl-patient]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tl-patient]');
    if (root) {
      delete root.dataset.patientReady;
      init(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-pricing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-pricing-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-pricing-hero::before y lee esta variable.
        hero.style.setProperty('--tl-pricing-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-providers"] && !Shopify.designMode) return;
  try {
    
/* -------------------------------------------------------------------------
   Trueloom Providers Form — real-time input filters
   NAME_RE: letters, spaces, hyphens, apostrophes, periods (titles like Dr.)
   PHONE: digits + formatting characters only
   ------------------------------------------------------------------------- */
(function () {
  const form = document.getElementById('tl-prov-form');
  if (!form) return;

  // Name filter: allow Dr., Jr., María, O'Neill, Jean-Luc, etc.
  const NAME_ALLOW = /[^A-Za-zÀ-ÿ'’\-.\s]/g;
  // Phone filter: digits + ( ) - + space
  const PHONE_ALLOW = /[^0-9()+\-\s]/g;

  form.querySelectorAll('[data-filter="name"]').forEach(function (el) {
    el.addEventListener('input', function () {
      const start = el.selectionStart;
      const cleaned = el.value.replace(NAME_ALLOW, '');
      if (cleaned !== el.value) {
        el.value = cleaned;
        try { el.setSelectionRange(start - 1, start - 1); } catch (e) {}
      }
    });
  });

  form.querySelectorAll('[data-filter="phone"]').forEach(function (el) {
    el.addEventListener('input', function () {
      const start = el.selectionStart;
      const cleaned = el.value.replace(PHONE_ALLOW, '');
      if (cleaned !== el.value) {
        el.value = cleaned;
        try { el.setSelectionRange(start - 1, start - 1); } catch (e) {}
      }
    });
  });

  // After successful post, Shopify reloads with ?contact_posted=true in URL.
  // Auto-scroll to the success panel so user sees confirmation.
  if (window.location.hash === '#contact_posted' ||
      /contact_posted=true/.test(window.location.search)) {
    const intake = document.getElementById('intake');
    if (intake) intake.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trueloom-verification"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var hero = document.querySelector('.tl-vf-hero');
    if (!hero || reduce.matches) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Solo animamos mientras el hero está (parcial o totalmente) en pantalla.
      if (rect.bottom > 0 && rect.top < vh) {
        // Progreso 0→1 desde que el hero entra por abajo hasta que sale por arriba.
        var total = vh + rect.height;
        var p = (vh - rect.top) / total;
        p = Math.max(0, Math.min(1, p));

        // Recorrido acotado (±15% de la altura) — cabe en el 20% de overflow de la capa.
        var maxShift = rect.height * 0.15;
        var offset = (p - 0.5) * 2 * maxShift;

        // La capa de imagen es .tl-vf-hero::before y lee esta variable.
        hero.style.setProperty('--tl-vf-parallax', offset.toFixed(2) + 'px');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
